import React, { Component } from 'react';
import { Toast,  WhiteSpace, List } from 'antd-mobile';
import { CommonlyHeadMembers } from '../../common/headnav';
import * as services from '../../projects/services';
import { createBrowserHistory } from "history";
import './style.less';
import { Button } from 'antd';
const history = createBrowserHistory();
export default class EditReportPSW extends Component {
    constructor(props) {
        super(props);
        this.state = {
            params: { mcname:this.props.match.params.mcname,hospitalno: this.props.match.params.mcno, tjbh: this.props.match.params.tjbh, oldpsw: '', newpsw: '', confirmpsw: '',
            password:this.props.match.params.password }
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let params = this.state.params;
        params[name] = value;
        this.setState({
            params: params
        });
    }
    edit = () => {
        // hospitalno,tjbh,oldpsw,newpsw,confirmpsw
        let params = this.state.params;
        if (this.state.params.oldpsw === '' || this.state.params.oldpsw.length < 6) {
            Toast.offline('请输入正确的报告密码！', 2);
            return false;
        }
        if (this.state.params.newpsw === '' || this.state.params.newpsw.length < 6) {
            Toast.offline('请输入正确的新密码！', 2);
            return false;
        }
        if (this.state.params.confirmpsw !== this.state.params.newpsw) {
            Toast.offline('两次输入的密码不一致，请重新输入', 2);
            return false;
        }
        if(this.state.params.oldpsw  !== this.state.params.password)
        {            
            Toast.offline('查询密码输入错误，请重新输入', 2);
            return false;
        }
         services.ModifyReportpsw(params,'正在修改请稍后').then(data => {
            if (data.status === 0) {
               Toast.loading('密码修改成功！', 2, () => {
                history.push('/members/report');
                history.go();
              });
            }else
            {
                Toast.offline(data.message, 2);
            }
        });
    }
    render() {
        return <div className="report">
            <CommonlyHeadMembers barname="修改报告密码" />
            <div className="addreportbox2" >
                <List renderHeader={() => '*所有项目必填，密码大于等于6位'}>
                    <List.Item>
                        <span className="name">体检医院：</span>
                        <input type="text" disabled name="hospitalno" value={this.state.params.mcname} />
                    </List.Item>
                    <List.Item>
                        <span className="name">体检编号：</span>
                        <input type="text" disabled name="tjbh" value={this.state.params.tjbh} />
                    </List.Item>

                    <List.Item>
                        <span className="name">查看密码</span><input type="password" name="oldpsw" placeholder="请输入体检报告查询密码" onChange={this.handleInputChange} />
                    </List.Item>
                    <List.Item>
                        <span className="name">新密码：</span><input type="password" name="newpsw" placeholder="请输入体检报告新密码" onChange={this.handleInputChange} />
                    </List.Item>
                    <List.Item>
                        <span className="name">确认密码</span><input type="password" name="confirmpsw" placeholder="请输入体检报告新密码" onChange={this.handleInputChange} />
                    </List.Item>
                </List>
                <Button className="submitBut" onClick={this.edit} >密码修改</Button>
                <WhiteSpace />
            </div>
        </div>
    }
}